import { getDatabaseCart } from "./utilities/databaseManager";

export const searchByPrice = (searchList, listOfProduct, sessionList) => {
    if (searchList.length > 0) {
        searchList.filter(x => (
            listOfProduct.filter(item => {
                let testData = parseInt(item.price) >= parseInt(x.startPrice) && parseInt(item.price) <= parseInt(x.endPrice)
                if (testData) {
                    sessionList.push(item)
                }
                return 0;
            })
        ))
    }
}

export const SearchByBrandName = (searchList, listOfProduct, sessionList) => {
    if (searchList.length > 0) {
        searchList.filter(x => (
            listOfProduct.filter(item => {
                let testData = item.brand === x.brandName
                if (testData) {
                    sessionList.push(item)
                }
                return 0;
            })
        ))
    }
}



export const spliceList = (range, index) => {
    const rangeList = range.filter(item => item.id !== index)
    return rangeList;
}


//VerticalLineStepeer
export const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export const handleNext = (setActiveStep) => setActiveStep((prevActiveStep) => prevActiveStep + 1);

export const handleBack = (setActiveStep) => setActiveStep((prevActiveStep) => prevActiveStep - 1);

export const handleReset = (setActiveStep) => setActiveStep(0);

export const handleResize = (setWindowDimensions, getWindowDimensions) => setWindowDimensions(getWindowDimensions());


export const removeFromCart = (key, removeFromDatabaseCart, setRefresh) => {
    removeFromDatabaseCart(key)
    setRefresh(true)
}

export const deliveryData = (name, email, zip, houseFlat, street, landmark, city, phoneNumber, setName, setEmail, setZip, setHouseFlat, setStreet, setLandMark, setCity, setPhoneNumber) => (
    [
        { title: 'NAME', states: name, setStates: setName, name: 'name' },
        { title: 'EMAIL', states: email, setStates: setEmail, name: 'email' },
        { title: 'ZIP / PIN / POST CODE', states: zip, setStates: setZip, name: 'zip' },
        { title: 'HOUSE / FLAT / BLOCK NO /  BUILDING NAME', states: houseFlat, setStates: setHouseFlat, name: 'house' },
        { title: 'STREET / ROAD / COLONY NAME', states: street, setStates: setStreet, name: 'street' },
        { title: 'LANDMARK', states: landmark, setStates: setLandMark, name: 'landmark' },
        { title: 'CITY', states: city, setStates: setCity, name: 'city' },
        { title: 'PHONE NO', states: phoneNumber, setStates: setPhoneNumber, name: 'phone' },
    ]
)

export const inconList = (HomeIcon, CategoryIcon, CollectionsIcon, ReviewsIcon, InfoIcon, CallIcon) => (
    [
        { title: 'Home', icon: HomeIcon, to: '/' },
        { title: 'Categories', icon: CategoryIcon, to: '/categories' },
        { title: 'Gallery', icon: CollectionsIcon, to: '/gallery' },
        { title: 'Testimonials', icon: ReviewsIcon, to: '/testimonial' },
        { title: 'About Us', icon: InfoIcon, to: '/about-us' },
        { title: 'Contact Us', icon: CallIcon, to: '/contact-us' }
    ]
)
export const profileIconList = (BackpackIcon, PreviewIcon, LoginIcon, email, emailVerified) => (
    [
        { title: 'My Orders', icon: BackpackIcon, to: '/my-orders' },
        { title: 'My List', icon: PreviewIcon, to: '/reviewList' },
        { title: `${email && emailVerified ? 'Sign Out' : 'Sign In'}`, icon: LoginIcon, to: '/login' },
    ]
)

export const datePicker = (date) => {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();

    const finalDate = mm + '/' + dd + '/' + yyyy;
    return finalDate;
}

export const previousCart = (data) => {
    const savedCart = getDatabaseCart();
    const productKeys = Object.keys(savedCart);

    return productKeys.map(existingKey => {
        const product = data?.find(pd => pd.uniqueId === existingKey)
        const newProduct = { ...product };

        newProduct.orderQuantity = savedCart[existingKey];
        return newProduct;
    })
}


export const fetchSearchData = async (searchValue, setStates, getSearchData, navigate) => {

    const { setSearchLoading: setSearchLoadingTrue, setProductData, setDocumentsData, setSearchLoading: setSearchLoadingFalse } = setStates;
    setSearchLoadingTrue(true);
    try {
        const { afterSplice, categoryItem } = await getSearchData
        setProductData(afterSplice);
        setDocumentsData(categoryItem)
        setSearchLoadingFalse(false);
        navigate(`/search-item/${searchValue}`);
    } catch (error) {
        // console.log(error)
    }

    return 0;
}

export const fetchCategoryWiseData = (categoryData, setStates) => {
    const { setSearchLoading: setSearchLoadingTrue, setProductData, setDocumentsData, setSearchLoading: setSearchLoadingFalse } = setStates;

    setSearchLoadingTrue(true);
    setProductData(categoryData?.afterSplice);
    setDocumentsData(categoryData?.categoryItem)
    setSearchLoadingFalse(false);
    return
}

export const sortingViaPrice = (currentStatus, currentDatatype, setStates) => {

    const { setProductData } = setStates;
    const { getSearchData, categoryData, currentData } = currentDatatype;
    if (currentStatus === 'price-high-to-low') {
        const copiedSearchData = [...getSearchData?.afterSplice];
        const copiedCategoryData = [...categoryData?.afterSplice];
        setProductData((copiedCategoryData.length > 0 ? copiedCategoryData : copiedSearchData)?.sort((a, b) => parseInt(b.price) - parseInt(a.price)))
    } else if (currentStatus === 'price-low-to-high') {
        const copiedSearchData = [...getSearchData?.afterSplice];
        const copiedCategoryData = [...categoryData?.afterSplice];

        setProductData((copiedCategoryData.length > 0 ? copiedCategoryData : copiedSearchData)?.sort((a, b) => parseInt(a.price) - parseInt(b.price)))
    } else {
        setProductData(currentData);
    }
}